import ApiRequest from '../request'
import { backofficeRequest } from '../../axios'

export default class Ags {
  constructor() {
    this.apiRequest = new ApiRequest()
    this.apiRequestInternal = new ApiRequest({ useWindowLocation: true })
  }
  async getVpc({ ag_id, coowner_id }) {
    try {
      const res = await this.apiRequest.get(`ags/${ag_id}/vpc/${coowner_id}`)
      return res
    } catch (error) {
      return error.response
    }
  }
  async getConvocationPreview(ag_id) {
    try {
      const res = await this.apiRequest.get(`ags/${ag_id}/convocation_preview`)
      return res
    } catch (error) {
      return error.response
    }
  }
  async getDetailsCoownerAndAgs({ ag_id, coowner_id }) {
    try {
      const res = await this.apiRequestInternal.get(
        `ags/${ag_id}/coowners/${coowner_id}`
      )
      return res
    } catch (error) {
      return error.response
    }
  }
  async getAnnexes(code) {
    try {
      const res = await this.apiRequest.get(`ext_ags2d/${code}`)
      return res
    } catch (error) {
      return error.response
    }
  }
  async getConvocations(ag_id) {
    try {
      const res = await this.apiRequest.get(`/ags/${ag_id}/convocations`)
      return res
    } catch (error) {
      return error.response
    }
  }
  async getConvocationRecipients(ag_id) {
    try {
      const res = await this.apiRequest.get(
        `/ags/${ag_id}/convocation-recipients`
      )
      return res
    } catch (error) {
      return error.response
    }
  }

  async registerCoowners(ag_id, coowners) {
    try {
      const res = await this.apiRequest.post(
        `/ags2/${ag_id}/registrations`,
        coowners
      )
      return res
    } catch (error) {
      return error.response
    }
  }
  async getConvocationInformations(ag_id) {
    try {
      const res = await this.apiRequest.get(`/ags/${ag_id}/convocation_info`)
      return res
    } catch (error) {
      return error.response
    }
  }
  async convoke(ag_id) {
    try {
      const res = await this.apiRequest.post(`/ags/${ag_id}/convoke`)
      return res
    } catch (error) {
      return error.response
    }
  }

  async runOrCancelConvocationTask(
    condoId,
    task_name,
    task_id,
    generalAssemblyId,
    action
  ) {
    try {
      const res = await backofficeRequest.post(
        `backoffice/condominiums/${condoId}/general-assemblies/convocation/task/${action}`,
        {
          taskName: task_name,
          taskId: task_id,
          generalAssemblyId,
        }
      )
      return res
    } catch (error) {
      return error.response
    }
  }

  async getCanForceConvocation(condoId, generalAssemblyId) {
    try {
      const res = await backofficeRequest.get(
        `backoffice/condominiums/${condoId}/general-assemblies/${generalAssemblyId}/can-force-convocation`
      )
      return res.data
    } catch (error) {
      return error.response
    }
  }
  async updateAutoTrigger(ag_id, data) {
    try {
      const res = await this.apiRequest.put(`/ags/${ag_id}/autotrigger`, data)
      return res
    } catch (error) {
      return error.response
    }
  }
  async getOpponents(id) {
    try {
      const res = await this.apiRequest.get(`ags/${id}/opponents`)
      return res
    } catch (error) {
      return error.response
    }
  }
  async getOpponentInformations(id) {
    try {
      const res = await this.apiRequest.get(`ags/${id}/opponents_info`)
      return res
    } catch (error) {
      return error.response
    }
  }
  async confirmPassword(data) {
    try {
      const res = await this.apiRequest.post(
        `/agregistrations/confirm_password`,
        data
      )
      return res
    } catch (error) {
      return error.response
    }
  }
  async sendPv(id, data) {
    try {
      const res = await this.apiRequest.post(`ags/${id}/opponents/send`, {
        ...data,
      })
      return res
    } catch (error) {
      return error.response
    }
  }

  async getFiscalClosureStatusAndAccountant(condoId, id) {
    try {
      return await backofficeRequest.get(
        `backoffice/condominiums/${condoId}/general-assemblies/${id}/fiscal-years/is-closed`
      )
    } catch (error) {
      return error.response
    }
  }
}
